import { MDBBtn, MDBContainer } from "mdbreact";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ErrorContainer } from "../../../containers/Error";
import classes from "./ErrorPage.module.scss";

/**
 * エラー画面コンポーネント
 */
const ErrorPage: React.FC = () => {
  const history = useHistory();
  const errorContainer = ErrorContainer.useContainer();
  const error = errorContainer.error;

  useEffect(() => {
    if (error.error && error.retryCount === 0) {
      // エラー発生時は1回リトライを行う
      errorContainer.retry();
      history.push(`/entry`);
      return;
    }
  }, [error.error, error.retryCount, history, errorContainer]);

  /**
   * 再読み込みボタンクリック
   */
  const handleReloadClick = () => {
    errorContainer.resetError();
    history.go(0);
  };

  return (
    <MDBContainer fluid className={`${classes.bgDot} p-0`}>
      <div className={`${classes.errorTitle} py-3`}>{error.title}</div>
      <div className={`${classes.errorBody} text-center d-flex flex-column`}>
        <div className="mt-5">
          {error.message.map((msg, index) => {
            return <div key={index}>{msg}</div>;
          })}
        </div>
        <div className={`${classes.buttonContainer} mt-auto mb-3 text-center`}>
          <MDBBtn
            className={`${classes.reloadButton} my-0 py-3`}
            onClick={() => handleReloadClick()}
          >
            再読み込み
          </MDBBtn>
        </div>
      </div>
    </MDBContainer>
  );
};

export default ErrorPage;
